/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { ControlledVocab } from "@folio/stripes/smart-components";
import { IntlConsumer, TitleManager } from "@folio/stripes/core";
import { getSourceSuppressor } from "@folio/stripes/util";

import { RECORD_SOURCE } from "../constants";

class ContributorNameTypesSettings extends React.Component {
  static propTypes = {
    stripes: PropTypes.shape({
      connect: PropTypes.func.isRequired,
      hasPerm: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.connectedControlledVocab = props.stripes.connect(ControlledVocab);
  }

  render() {
    const hasPerm = this.props.stripes.hasPerm("ui-inventory.settings.list");
    const suppress = getSourceSuppressor([
      RECORD_SOURCE.FOLIO,
      RECORD_SOURCE.CONSORTIUM,
    ]);

    return (
      <IntlConsumer>
        {(intl) => (
          <TitleManager
            page={intl.formatMessage({
              id: "ui-inventory.settings.inventory.title",
            })}
            record={intl.formatMessage({
              id: "ui-inventory.contributorNameTypes",
            })}
          >
            <this.connectedControlledVocab
              {...this.props}
              baseUrl="contributor-name-types"
              records="contributorNameTypes"
              label={
                <FormattedMessage id="ui-inventory.contributorNameTypes" />
              }
              labelSingular={intl.formatMessage({
                id: "ui-inventory.contributorNameType",
              })}
              objectLabel={<FormattedMessage id="ui-inventory.contributors" />}
              visibleFields={["name"]}
              columnMapping={{
                name: intl.formatMessage({ id: "ui-inventory.name" }),
              }}
              hiddenFields={["description", "numberOfObjects"]}
              nameKey="name"
              // actionSuppressor={{ edit: suppress, delete: suppress }}
              id="contributor-name-types"
              sortby="ordering"
              // editable={hasPerm}
            />
          </TitleManager>
        )}
      </IntlConsumer>
    );
  }
}

export default ContributorNameTypesSettings;
